export const InvoiceTransportType = {
  Carrier: "Przewoźnik",
  FreightForwarder: "Spedycja"
};